import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { onMounted, watch, computed, ref } from 'vue';
    import { useStore } from 'vuex';
    import { useRoute, useRouter } from 'vue-router';
    import 'vue3-toastify/dist/index.css';
    import { useLayout } from '@/composables/useLayout';
    import Breadcrumbs from '@/components/navigation/Breadcrumbs.vue';
    import LockQueueModal from '@/components/shared/modals/LockQueueModal.vue';
    import AQChatbot from '@/components/shared/chatbot/AQChatbot.vue';
    import MessageModal from '@/components/shared/modals/MessageModal.vue';
    import { WEB } from '@/constants/platforms';
    import $rq from './api/api';
    import { ReleaseNoteData, DisplayNoteData } from '@/interfaces/common';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const currentTeamName = computed<string | null>(() => store.getters['currentTeamName'] || null);

    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();
    const isRouterReady = ref(false);
    router.isReady().then(() => {
        isRouterReady.value = true;
    });

    const { dynamicAppClasses, isMainLayoutActive } = useLayout();
    const release = ref<ReleaseNoteData>();
    const showMessageModal = ref(false);
    const isReleaseNote = ref(false);

    const showChatbot = computed<boolean>(() => {
        return (
            store.getters.isLoggedIn &&
            store.getters.showGenAIByFeature &&
            store.getters.getCurrentUser?.asAiActivated
        );
    });

    const userLang = computed<string>(() => store.getters.userLang || 'en');
    const currentMember = computed(() => store.getters.getCurrentUser);
    const displayNote = computed(() => store.getters.displayNote);
    const isFirstLoginSession = computed(() => store.getters.isFirstLoginSession);

    const getReleaseMessage = computed(() => {
        return release.value?.note?.message
            ? release.value.note.message[userLang.value as 'en' | 'fr']
            : t('forceUpdate.message');
    });

    const getReleaseTitle = computed(() => {
        return release.value?.title ? release.value.title[userLang.value as 'en' | 'fr'] : '';
    });
    const getReleaseInfo = async () => {
        const { data } = await $rq.getRelease({ platform: WEB });
        if (data[WEB]?.id && data[WEB].displayInNextLogin) {
            release.value = data[WEB];
        }
    };

    const handleNoteClose = async (dontShowAgain: boolean) => {
        await $rq.updateDisplayNote(currentMember.value.id, {
            displayNote: { displayNote: !dontShowAgain, platform: WEB },
        } as DisplayNoteData);
        showMessageModal.value = false;
        isReleaseNote.value = false;
    };

    const openReleaseNotes = async () => {
        await getReleaseInfo();
        isReleaseNote.value = true;
        showMessageModal.value = true;
    };

    onMounted(() => {
        store.dispatch('navigation/loadInitialNavigation');
    });
    // Watch displayNote - set by setAccessControlInfo after team selection
    watch(displayNote, async (newVal) => {
        if (!newVal || !isFirstLoginSession.value) return;
        if (currentMember.value?.displayNote[WEB]) {
            await openReleaseNotes();
        }
        store.dispatch('setFirstLoggedInSession', false);
    });

    // Watch for route changes to update sidebar expansion and content
    watch(
        () => route.path,
        (newPath) => {
            if (newPath) {
                store.dispatch('navigation/updateSidebarStateForRoute', newPath);
            }
        },
        { immediate: true },
    );

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: _normalizeClass(_unref(dynamicAppClasses))
  }, {
    default: _withCtx(() => [
      (!isRouterReady.value)
        ? (_openBlock(), _createBlock(_component_v_overlay, {
            key: 0,
            persistent: "",
            class: "align-center justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                size: "64",
                color: "primary"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (showMessageModal.value && isReleaseNote.value)
        ? (_openBlock(), _createBlock(MessageModal, {
            key: 1,
            show: showMessageModal.value,
            message: getReleaseMessage.value,
            title: getReleaseTitle.value,
            isReleaseNote: isReleaseNote.value,
            onClose: handleNoteClose
          }, null, 8, ["show", "message", "title", "isReleaseNote"]))
        : _createCommentVNode("", true),
      _createVNode(LockQueueModal),
      (_unref(isMainLayoutActive))
        ? (_openBlock(), _createBlock(_component_Navbar, {
            key: 2,
            onOpenReleaseNotes: openReleaseNotes
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, { class: "main-content-area" }, {
        default: _withCtx(() => [
          (currentTeamName.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                noGutters: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(Breadcrumbs)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_component_router_view, {
            key: _unref(route).fullPath
          }))
        ]),
        _: 1
      }),
      (showChatbot.value)
        ? (_openBlock(), _createBlock(AQChatbot, { key: 3 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})